var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-mobile-container"},[_c('header-icon-menu'),_vm._v(" "),_c('header-icon-favorite',{on:{"click":function($event){return _vm.$emit('click:favorite')}}}),_vm._v(" "),_c('header-mobile-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }